import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from './App';
import { VaultProvider } from './vault';
import './styles.css';

const root = document.getElementById('root');
if (!root) throw new Error('#root is missing from index.html');

/*
 * Register the shell cache.
 *
 * Failure is not worth reporting: without it the app simply needs a network,
 * which is where it started.
 */
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    void navigator.serviceWorker.register('/sw.js').catch(() => undefined);
  });
}

createRoot(root).render(
  <StrictMode>
    <VaultProvider>
      <App />
    </VaultProvider>
  </StrictMode>,
);
